module.exports = __webpack_public_path__ + "static/media/new.eeea5591.png";